<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    switchFullscreen
    @ok="handleOk"
    :ok-disabled="disableSubmit"
    :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
    @cancel="handleCancel"
    :okText="okText"
    cancelText="关闭">
    <pre-customer-form ref="realForm" @ok="submitCallback"  @handlerNextPage="handlerNextPage" :disabled="disableSubmit"></pre-customer-form>
  </j-modal>
</template>

<script>

  import PreCustomerForm from './PreCustomerForm'
  export default {
    name: 'PreCustomerModal',
    components: {
      PreCustomerForm
    },
    data () {
      return {
        title:'',
        width:1200,
        visible: false,
        disableSubmit: false,
        okText:'下一步',
      }
    },
    methods: {
      handlerNextPage(model) {
        this.visible=false
        this.$emit('handlerNextPage', model)
      },
      add () {
        this.okText = '下一步'
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.add();
        })
      },
      edit (record) {
        console.log('record : ',record)
        console.log('this.disableSubmit : ',this.disableSubmit)
        if (record.pageState === 1 ||  record.pageState === 3) {
          this.okText = '确定'
        } else {
          this.okText = '下一步'
        }    
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.edit(record);
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        if (this.disableSubmit) {
          //详情
          this.close()
          //重置状态
          this.disableSubmit = false
          this.okText = '下一步'
        } else {
          this.$refs.realForm.submitForm();
        }
      },
      submitCallback(){
        console.log('11111')
        this.$emit('ok');
        this.visible = false;
      },
      handleCancel () {
        this.close()
      },

    }
  }
</script>